import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Verifier() {
  const { numero, token } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/verifier/${numero}/${token}`)
      .then((r) => r.json())
      .then(setResult)
      .catch(() => setResult({ valid: false }));
  }, [numero, token]);

  if (!result) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#141414]" data-testid="verifier-loading">
        <p className="text-sm text-white/40">Vérification du billet...</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#141414] px-6" data-testid="verifier-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className={`w-full max-w-md rounded-3xl border p-10 text-center backdrop-blur-xl ${
          result.valid ? "border-gold/60 bg-[#0a0a0a]/80" : "border-red-500/50 bg-[#1a0505]/80"
        }`}
      >
        {result.valid ? (
          <>
            <CheckCircle2 className="mx-auto h-20 w-20 text-gold" data-testid="verifier-valid-icon" />
            <h1 className="mt-6 font-display text-4xl tracking-tight text-gold" data-testid="verifier-valid-title">
              BILLET VALIDE
            </h1>
            <div className="mt-8 space-y-3 text-sm">
              <p className="text-white/40">
                N° <span className="font-display text-lg text-white" data-testid="verifier-numero">{result.numero}</span>
              </p>
              <p className="text-white/40">
                Nom <span className="block text-xl font-semibold text-white" data-testid="verifier-name">{result.name}</span>
              </p>
              <p className="text-white/40">
                Catégorie{" "}
                <span className="ml-2 rounded-full bg-gold/15 px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] text-gold" data-testid="verifier-categorie">
                  {result.categorie}
                </span>
              </p>
              <p className="text-white/40">
                Personnes <span className="text-lg font-semibold text-white" data-testid="verifier-personnes">{result.personnes}</span>
              </p>
              <p className="pt-4 text-[10px] uppercase tracking-[0.25em] text-white/30">
                Soirée VIP — 14 novembre — Factory58, Bobigny
              </p>
            </div>
          </>
        ) : (
          <>
            <XCircle className="mx-auto h-20 w-20 text-red-500" data-testid="verifier-invalid-icon" />
            <h1 className="mt-6 font-display text-4xl tracking-tight text-red-500" data-testid="verifier-invalid-title">
              BILLET INVALIDE
            </h1>
            <p className="mt-4 text-sm text-white/50">
              Ce billet n'est pas reconnu. Vérifiez le QR code ou contactez l'organisation.
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}
